import actions from "~/shared/actions";

const defaultState = {
	global: undefined,
	readingModeError: false,
	rpmAccessError: false,
	validationErrors: [],
};

export default function error(state = defaultState, action) {
	switch (action.type) {
		case actions.ERROR:
			return {
				...state,
				global: action.data,
			};
		case actions.CLEAR_ERROR:
			return {
				...state,
				global: undefined,
			};
		case actions.SERVER_VALIDATION_ERROR:
			return {
				...state,
				validationErrors: action.data.message.split(";").map((field) => ({ [field.split(":")[0]]: field.split(":")[1] })),
			};
		case actions.CLEAR_VALIDATION_ERROR:
			return {
				...state,
				validationErrors: [],
			};
		case actions.READING_MODE_ERROR:
			return {
				...state,
				readingModeError: true,
			};
		case actions.RPM_ACCESS_ERROR:
			return {
				...state,
				rpmAccessError: true,
			};
		default:
			return state;
	}
}
